export default {
  "404": () => import("/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/layouts/404.vue").then(m => m.default || m)
}